import React from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Plus, X } from "lucide-react";
import { EXTRA_PRESETS } from "../lib/invoice";

export const ExtrasEditor = ({ value, onChange }) => {
  const set = (i, k, v) => onChange(value.map((e, j) => (j === i ? { ...e, [k]: v } : e)));
  const add = () => onChange([...value, { name: "", qty: 1, price: "" }]);
  const remove = (i) => onChange(value.filter((_, j) => j !== i));

  return (
    <div data-testid="extras-editor" className="space-y-2">
      <Label>Extra charges</Label>
      <datalist id="extra-presets">
        {EXTRA_PRESETS.map((p) => <option key={p} value={p} />)}
      </datalist>
      {value.map((e, i) => (
        <div key={i} className="grid grid-cols-[1fr_70px_110px_32px] gap-2 items-center">
          <Input data-testid={`extra-name-${i}`} list="extra-presets" value={e.name} onChange={(ev) => set(i, "name", ev.target.value)} placeholder="Pick or type, e.g. Laundry" />
          <Input data-testid={`extra-qty-${i}`} type="number" min="1" step="1" value={e.qty} onChange={(ev) => set(i, "qty", ev.target.value)} placeholder="Qty" />
          <Input data-testid={`extra-price-${i}`} type="number" min="0" step="0.01" value={e.price} onChange={(ev) => set(i, "price", ev.target.value)} placeholder="Price ₹" />
          <button type="button" data-testid={`extra-remove-${i}`} onClick={() => remove(i)} className="h-9 w-8 inline-flex items-center justify-center text-neutral-500 hover:text-[#c8102e]" title="Remove"><X size={16} /></button>
        </div>
      ))}
      <button type="button" data-testid="extra-add-btn" onClick={add} className="inline-flex items-center gap-1 text-sm text-[#c8102e] hover:underline">
        <Plus size={14} /> Add charge
      </button>
    </div>
  );
};
